export default () =>
  import(/* webpackChunkName: 'coffee/app/agreement/list' */ './AgreementList');
